"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZlListRequest = void 0;
var ZlListRequest = /** @class */ (function () {
    function ZlListRequest() {
    }
    return ZlListRequest;
}());
exports.ZlListRequest = ZlListRequest;
;
//# sourceMappingURL=zlList.request.js.map